import React from 'react';
import { HStack, Button, Icon } from '@chakra-ui/react';

const SocialLoginSection = ({ onPhoneClick, onEmailClick }) => (
  <HStack spacing={3} w="full" mb={2}>
    <Button
      variant="outline"
      w="full"
      leftIcon={<img src="/png/google.png" alt="google" style={{width: '18px', height: '18px'}} />}
      borderRadius="md"
      fontWeight="medium"
      onClick={onEmailClick}
    >
      Google
    </Button>
    <Button
      variant="outline"
      w="full"
      leftIcon={<img src="/png/phone.png" alt="phone" style={{width: '18px', height: '18px'}} />}
      borderRadius="md"
      fontWeight="medium"
      onClick={onPhoneClick}
    >
      Phone
    </Button>
  </HStack>
);

export default SocialLoginSection; 